import { useState, useEffect } from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import environment, { electronOnly } from "src/utils/environment";
import IconAsButton from "src/components/IconAsButton";
import { Activities } from "src/modules/activity-log/activity";
import { ReactComponent as BackIcon } from "./back.svg";

const remote = window.require("@electron/remote");

function BackToFocusedStation({ onClick, station, ...rest }) {
  const { colorMode } = useColorMode();
  const browserWindow = remote?.getCurrentWindow?.();
  const fullScreen = browserWindow?.isFullScreen();

  const [isFullScreen, setIsFullScreen] = useState(fullScreen);

  useEffect(() => {
    function handleFullScreenChange() {
      const fullScreen = browserWindow.isFullScreen();
      setIsFullScreen(fullScreen);
    }
    electronOnly(() => {
      browserWindow.on("enter-full-screen", handleFullScreenChange);
      browserWindow.on("leave-full-screen", handleFullScreenChange);
    });
    return () => {
      electronOnly(() => {
        browserWindow.off("enter-full-screen", handleFullScreenChange);
        browserWindow.off("leave-full-screen", handleFullScreenChange);
      });
    };
  }, [browserWindow]);

  const countAsDarkMode =
    station.error ||
    colorMode === "dark" ||
    station.activity === Activities.AWAKE ||
    station.activity === Activities.MOTION;

  return (
    <Box
      zIndex="100"
      position="absolute"
      top="5px"
      left={environment.isMacOs ? (isFullScreen ? "14px" : "74px") : "14px"}
      {...rest}
    >
      <IconAsButton
        onClick={onClick}
        fill={
          station.mode === "video"
            ? "white"
            : countAsDarkMode
            ? "white70"
            : "black54"
        }
        icon={BackIcon}
        size="20px"
      />
    </Box>
  );
}

export { BackToFocusedStation };
